var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6 2.00001C11.7872 1.99941 11.9709 2.05125 12.13 2.14963C14.54 3.65587 20 7.75561 20 14.02C20 18.4272 16.4183 22 12 22C7.58172 22 4 18.4272 4 14.02C4 11.7596 4.86326 10.4052 5.66807 9.14253C6.28396 8.17625 6.86561 7.26367 7 6.0399C6.99739 5.87721 7.07612 5.72389 7.21 5.63093C7.34493 5.56169 7.50507 5.56169 7.64 5.63093C8.56773 6.0345 9.3993 6.62942 10.08 7.37656C10.2001 7.56211 10.4283 7.64672 10.6408 7.58452C10.8533 7.52232 10.9994 7.32812 11 7.10724V2.49876C11 2.2233 11.2239 2.00001 11.5 2.00001H11.6ZM8 15.9651C8 18.1687 9.79086 19.9551 12 19.9551C14.2091 19.9551 16 18.1687 16 15.9651C15.855 13.1791 13.9629 10.7879 11.28 10C11.1483 9.98166 11.0253 10.0693 11 10.1995C10.8887 10.8023 10.3917 11.4114 9.83326 12.0958C8.98713 13.1328 8 14.3426 8 15.9651Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.fa53538272926b875d2086ce8bd24ed2.svg";
export { ForwardRef as ReactComponent };